import { has, get } from "lodash"
import locales from "./../../../content.json"

export const checkIsValidHelp = data => {
    let isValid = false

    Object.keys(helpData).map((key) => {
        if (has(data, ["help", key]) && get(data, ["help", key], false))
            isValid = true
    })

    return isValid
}

export const helpData = {
    tips: {
        value: "tips",
        title: locales[window.userLang].tips,
        icon: "img/icon-tips.png"
    },
    seeing: {
        value: "seeing",
        title: locales[window.userLang].seeing,
        icon: "img/icon-seeing.png"
    },
    training: {
        value: "training",
        title: locales[window.userLang].training,
        icon: "img/icon-training.png"
    },
    supportive: {
        value: "supportive",
        title: locales[window.userLang].supportive,
        icon: "img/icon-supportive.png"
    },
    guidelines: {
        value: "guidelines",
        title: locales[window.userLang].guidelines,
        icon: "img/icon-guidelines.png"
    },
    appleRings: {
        value: "appleRings",
        title: locales[window.userLang].apple_rings,
        icon: "img/icon-applerings.png"
    },
}

export const defaultFasting = false